'use client';

import { c as _c } from "react/compiler-runtime";
import { Tab } from '@common/components';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useScrollToSection } from '@/hooks/useScrollToSection';
import { HOMETOWNS_DETAIL_TAB } from '../constants';
interface HometownsTabProps {
  tabs: {
    title: string;
    tab: HOMETOWNS_DETAIL_TAB;
  }[];
}
export const HometownsTab = t0 => {
  const $ = _c(15);
  const {
    tabs
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const searchParams = useSearchParams();
  const {
    scrollToSectionWithTab
  } = useScrollToSection();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get("tab") as HOMETOWNS_DETAIL_TAB ?? HOMETOWNS_DETAIL_TAB.GIFTS;
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tab = t1;
  let t2;
  let t3;
  if ($[2] !== scrollToSectionWithTab || $[3] !== searchParams) {
    t2 = () => {
      if (searchParams?.get("tab")) {
        scrollToSectionWithTab(searchParams.get("tab") as HOMETOWNS_DETAIL_TAB, {
          behavior: "instant",
          offset: 20
        });
      }
    };
    t3 = [scrollToSectionWithTab, searchParams];
    $[2] = scrollToSectionWithTab;
    $[3] = searchParams;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  const t4 = isDesktopViewport ? "lg" : "sm";
  let t5;
  if ($[6] !== scrollToSectionWithTab) {
    t5 = value => {
      scrollToSectionWithTab(value, {
        offset: 20
      });
    };
    $[6] = scrollToSectionWithTab;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== tabs) {
    t6 = tabs.map(_temp);
    $[8] = tabs;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== tab) {
    t7 = <Tab value={tab} size={t4} variant="full" onChange={t5} className="bg-Gray-white">{t6}</Tab>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = tab;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
function _temp(t0, index) {
  const {
    title,
    tab: tab_0
  } = t0;
  return <Tab.Item key={index} value={tab_0}>{title}</Tab.Item>;
}